import type { IconData } from '@stacksjs/iconify-core'

export const trendingContent: IconData = {
  "body": "<g fill=\"none\" stroke=\"currentColor\" stroke-linecap=\"round\" stroke-linejoin=\"round\" stroke-width=\"3\"><path d=\"M26.306 3.06c-1.096-.305-2.036.637-2.095 1.773c-.137 2.627-.65 5.565-2.07 7.495c-.685.932-2.01 1.158-2.832.344c-.91-.9-1.612-2.302-2.148-3.807c-.475-1.332-2.078-1.952-3.183-1.068c-5.405 4.327-10.98 10.954-10.98 19.88c0 11.96 9.403 17.325 21.002 17.325c11.6 0 21.002-5.365 21.002-17.325c0-12.222-10.451-20.133-16.608-23.733a8.8 8.8 0 0 0-2.088-.885\"/><path d=\"M23.273 23.332a1.64 1.64 0 0 1 1.454 0C26.698 24.301 32 27.39 32 32.6c0 4.418-3.582 6.4-8 6.4s-8-1.982-8-6.4c0-5.21 5.302-8.3 7.273-9.268\"/></g>",
  "width": 48,
  "height": 48,
  "viewBox": "0 0 48 48"
}

export default trendingContent
